import {
    useCallback,
    useMemo,
} from 'react'

import {
    DetailPanelComponentProps,
} from 'app/shared-components/SkyNetDataGridExpandable'
import longTermLeasePositionRequests from 'app/requests/LongTermLeasePosition/LongTermLeasePosition.requsts'
import StatusHandler from 'app/shared-components/StatusHandler'
import useGetLongTermLeasePosition
    from 'app/requests/LongTermLeasePosition/hooks/useGetLongTermLeasePosition'

import LongTermLeaseInvoicePositionForm from '../LongTermLeaseInvoicePositionForm'

const LongTermLeaseInvoicePositionUpdate = ({
    id, onSuccess, onCancel,
}: Readonly<DetailPanelComponentProps>) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetLongTermLeasePosition({
        longTermLeasePositionId: Number(id),
    })

    const requestParams = useMemo(() => {
        return longTermLeasePositionRequests.update({
            longTermLeasePositionId: Number(id),
        })
    }, [id])

    const handleSuccess = useCallback(({
        id: updatedId,
    }: {id: number}) => {
        onSuccess({
            id: updatedId,
        })
        invalidate()
    }, [
        invalidate,
        onSuccess,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <LongTermLeaseInvoicePositionForm
                data={data}
                onSuccess={handleSuccess}
                onCancel={onCancel}
                requestParams={requestParams}
                exists
            />
        </StatusHandler>
    )
}

export default LongTermLeaseInvoicePositionUpdate
